import { configureStore } from '@reduxjs/toolkit';
import loginSlice from '../features/login/LoginSlice';
import summarySlice from '../features/summary/SummarySlice';
import alarmSlice from '../features/alarm/AlarmSlice';
import checkSlice from '../features/check/CheckSlice';
import logSlice from '../features/log/LogSlice';

export const store = configureStore({
  reducer: {
    login: loginSlice.reducer,
    summary: summarySlice.reducer,
    alarm: alarmSlice.reducer,
    check: checkSlice.reducer,
    log: logSlice.reducer,
  },
});
